export * from "common/utils/strings";

import { TFunction } from "i18next";

export const formatList = (t: TFunction, list: string[]): string => {
  if (list.length === 0) {
    return "";
  }
  if (list.length === 1) {
    return t("utils.lists.1", { a: list[0] });
  }
  if (list.length === 2) {
    return t("utils.lists.2", { a: list[0], b: list[1] });
  }
  const first = list.shift() ?? "";
  const last = list.pop();
  let result = first;
  for (const item of list) {
    result = t("utils.lists.3+", { a: result, b: item });
  }
  result = t("utils.lists.+3", { b: result, c: last });
  return result;
};

export const valueOrLoading = (
  customerSerial: string | undefined,
  t: TFunction
): string => {
  if (customerSerial) {
    return customerSerial;
  } else {
    return t("components.Loading.placeholder");
  }
};

export interface StringDiff {
  added: string[];
  removed: string[];
}
export const getStringSetDiff = (a: string[], b: string[]): StringDiff => {
  const srcSet = new Set(a);
  const versusSet = new Set(b);
  const addedSet = versusSet.difference(srcSet);
  const removedSet = srcSet.difference(versusSet);

  return {
    added: [...addedSet],
    removed: [...removedSet],
  };
};
